import type { PropsWithChildren } from "react";

import { AnimatedWrapper } from "./styles";

type Props = PropsWithChildren<{
    isVisible: boolean;
}>;

export const AnimatedContextualSuggestions = ({ children, isVisible }: Props) => {
    if (!isVisible) {
        return null;
    }

    return <AnimatedWrapper data-automation="animated-contextual-suggestions">{children}</AnimatedWrapper>;
};
